export const POINT_FIELDS = [
  { place: 1, label: '1-е место' },
  { place: 2, label: '2-е место' },
  { place: 3, label: '3-е место' },
  { place: 4, label: '4-е место' },
  { place: 5, label: '5-е место' },
  { place: 6, label: '6-е место' },
  { place: 7, label: '7-е место' },
  { place: 8, label: '8-е место' },
]
